import "./table.scss";

import classNames from "classnames";
import React, { Children } from "react";

import TableActionRow from "./TableActionRow";

type TableProps = React.PropsWithChildren<{
  header: JSX.Element;
  actionRow?: {
    text: React.ReactNode;
    onClick: () => void;
    hasTableCellSpacer?: boolean;
  };
  className?: string;
  tableClassName?: string;
  fullWidth?: boolean;
}>;

const Table = (props: TableProps) => {
  return (
    <div
      className={classNames("generic-table-wrapper", props.className)}
      data-testid="generic-table"
    >
      <table
        className={classNames(
          "generic-table",
          props.tableClassName,
          props.fullWidth && "generic-table--full-width",
        )}
        cellPadding={0}
      >
        <thead>
          <tr>{props.header}</tr>
        </thead>
        <tbody>
          {props.actionRow && (
            <TableActionRow
              columnCount={
                props.actionRow.hasTableCellSpacer
                  ? Children.count(props.header?.props.children) - 1
                  : Children.count(props.header?.props.children)
              }
              {...props.actionRow}
            />
          )}
          {props.children}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
